import React from "react"
import InputField from "./stateless/InputField"
import { LoginBgArray, actionObjLocalReducer, InputFieldState, SignUpType, InputFieldObj } from "../const"
import { validateEmail, validateName } from "../validations"
import { sanitizeHTML, processTT } from "../functions"
import { useGlobalContext } from "../context"

function localReducer(state: InputFieldState, action: actionObjLocalReducer) {
    // console.log(state, action)
    const newState = { ...state }
    switch (action.type) {
        case "set-error":
            newState[action.payload[0]].err = action.payload[1]
            newState[action.payload[0]].val = ""
            return newState
        case "remove-error":
            newState[action.payload].err = ""
            return newState
        case "set-value":
            newState[action.payload[0]].err = ""
            newState[action.payload[0]].val = sanitizeHTML(action.payload[1])
            return newState

        case "set-validationFn":
            newState[action.payload[0]].validationFn = action.payload[1]
            return newState

        default:
            return state
    }
}

const IrPayment = () => {
    const { globalState, dispatch, log, t } = useGlobalContext()
    const [error, setError] = React.useState("")
    const [localState, localDispatch] = React.useReducer(localReducer, {
        payment_id: { val: "", err: "", required: true, validationFn: validateName },
        email: { val: "", err: "", required: true, validationFn: validateEmail },
        last4digit: { val: "", err: "", required: false, validationFn: (str: string) => (/^\d{4}$/.test(str) ? "" : "must be 4 digits") },
    })
    const [submission, setSubmission] = React.useState(false)

    const submitHandler = async (e: React.FormEvent) => {
        e.preventDefault()
        console.log(localState)

        const hasError = Object.entries(localState)
            .map(([key, value]) => {
                if (value.required && value.err) return key
                else if (value.required && !value.val) {
                    localDispatch({ type: "set-error", payload: [key, "Cannot be empty!"] })
                    return key
                }
                return ""
            })
            .filter((item) => Object.keys(localState).includes(item))

        if (hasError.length) return

        const data = Object.entries(localState).reduce((acc: any, curr) => {
            acc[curr[0]] = curr[1].val
            return acc
        }, {})

        await processTT(data).then((res) => {
            if (res.error) return setError(t(res.error))
            else if (res.json === "ok") {
                setSubmission(true)
            }
        })
    }

    return (
        <div className="login">
            <div className="content">
                <div>explanations....</div>
                {!submission && (
                    <form onSubmit={submitHandler}>
                        <h1>Sign-up Form</h1>
                        {globalState.error && <p>{t(globalState.error)}</p>}

                        <InputField field="email" label="ایمیل" state={localState} dispatch={localDispatch} />
                        <InputField field="payment_id" label="کد رهگیری / شماره فیش" state={localState} dispatch={localDispatch} />
                        <InputField field="last4digit" label="4 رقم آخر کارت" state={localState} dispatch={localDispatch} />

                        <div className="button-area">
                            {error && <p>{error}</p>}
                            <button type="submit">ثبت سفارش</button>
                            <br />
                        </div>
                    </form>
                )}
                {submission && <p>You have submitted the form successfuly, we will get back to you in 24 hours</p>}
            </div>
        </div>
    )
}

export default IrPayment